import { Component } from '@angular/core';
import { TransferHttpService } from '../../../services/transfer-http/transfer-http.service';
import { Router } from '@angular/router';
import { PermissionsService } from '../../../services/permissions/permissions.service';
import { TrainingFunctions } from '../functions/trainingFunctions';
import { AimsHub } from '../../../components/aimsHub/aimsHub';
import { CertificationQueueBaseComponent, ShowValue } from './certification-queue-base.component';
import { MatDialog } from '@angular/material/dialog';
import { combineLatest, map, tap } from 'rxjs';


@Component({
  selector: 'selfTrainedCert',
  templateUrl: './certify.component.html',
  styleUrls: ['../hr.component.css'],
  providers: [TrainingFunctions, AimsHub]
})

export class SelfTrainedCertQueueComponent extends CertificationQueueBaseComponent {

  constructor(public transferHttp: TransferHttpService,
    private router: Router,
    public permissions: PermissionsService,
    public tFunc: TrainingFunctions,
    public dialog: MatDialog,
    public selfTrainedCertHub: AimsHub) {
    super(transferHttp, dialog);
  }

  headerText = "Self-Trained Certification Queue -- From my Work Section";
  defaultText = "Show All From My Work Section";

  trainingTaskHistory = combineLatest([this.selfTrainedCertHub.getHot<Array<any>>('selfTrainedCerts'), this.showValue]).pipe(
      tap(([allTrs, showValue]) => {
        if (showValue == ShowValue.MyDept) {
          this.headerText = "Self-Trained Certification Queue -- All in my Department";
        }
        else if (showValue == ShowValue.AllDepts) {
          this.headerText = "Self-Trained Certification Queue -- All";
        }
        else {
          this.headerText = "Self-Trained Certification Queue -- From my Work Section";
        }
      }),
      map(([allTrs, showValue]) => {
        let filteredValues: Array<any> = [];

        if (showValue == ShowValue.MyDept) {
          filteredValues = allTrs.filter(t => t['qoeDeptId'] == this.user.departmentId);
        }
        else if (showValue == ShowValue.AllDepts) {
          filteredValues = allTrs;
        }
        else {
          filteredValues = allTrs.filter(t => t['qualTaskWsOwnerId'] == this.user.workSectionId);
        }

        return filteredValues;
      })
    );

  //***************************
  // Init
  //***************************

  ngOnInit(): void {
  }
}
